<script setup lang="ts">
import UIBanner from '@/components/ui/UIBanner.vue'
import UIMapBannerContainer from '@/components/ui/UIMapBannerContainer.vue'
import useLanguage from '@/composables/useLanguage'
import { computed, onBeforeUnmount, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()
const show = ref(false)
const i18n = useLanguage('ParticipantLinkBanner')

let hideBannerTimeout: ReturnType<typeof setTimeout> | null = null
const clearBannerTimeout = () => {
  if (hideBannerTimeout) {
    clearTimeout(hideBannerTimeout)
    hideBannerTimeout = null
  }
}

const flashBannerVisibility = () => {
  clearBannerTimeout()
  show.value = true

  hideBannerTimeout = setTimeout(() => {
    show.value = false
    hideBannerTimeout = null

    // remove query param
    const oldQuery = { ...route.query }
    delete oldQuery.from
    router.replace({ query: oldQuery })
  }, 15 * 1000)
}

const flashBannerClasses = computed(
  () =>
    `flash-banner transition-[opacity] duration-300 ease-in-out ${
      show.value ? 'show-flash-banner opacity-100' : 'opacity-0'
    }`
)

const isWithinSketch = computed(() => !!route.params?.uuid)

watch(
  () => route.query?.from,
  () => {
    if (route.query?.from === 'participant-link') {
      flashBannerVisibility()
    }
  },
  { immediate: true }
)

onBeforeUnmount(clearBannerTimeout)
</script>

<template>
  <UIMapBannerContainer variant="flash" class="flash-banners">
    <UIBanner
      :variant="isWithinSketch ? 'default' : 'slate'"
      :class="flashBannerClasses"
      data-testid="participant-link-banner"
      :aria-hidden="!show"
    >
      <!-- eslint-disable vue/no-v-html -->
      <p
        class="visible-hyperlinks"
        :class="show ? 'pointer-events-auto' : 'pointer-events-none'"
        v-html="isWithinSketch ? i18n.shareWarning : i18n.needAccess"
      ></p>
    </UIBanner>
  </UIMapBannerContainer>
</template>
